export const truncateText = (text) => {
  if (!text) return text;

  const lastSpace = text.lastIndexOf(" ");

  if (lastSpace === -1) return text;

  return `${text.substring(
    0,
    lastSpace,
  )} ... <em> (click <strong>Confirm</strong> to learn more)</em>`;
};
